import { useTranslation } from 'react-i18next';
import { Icon, Page } from '@/components';
import { AnnouncementsOverviewPanel } from '@/views';

export function AnnouncementOverviewPage() {
  const { t } = useTranslation();

  return (
    <Page htmlTitle={t('announcements.overview.title')}>
      <Page.Paths>
        <Page.Path>{t('announcements.overview.title')}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          title={t('announcements.overview.title')}
          icon={<Icon type="announcement" />}
          color="#814A93"
        >
          <AnnouncementsOverviewPanel />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
